import { HttpClient } from '@angular/common/http';
import {ChangeDetectionStrategy, Component, computed, inject, Injectable} from '@angular/core';
import {HeightService} from '../height/height.service';
import {PanelStylesService} from '../panel-styles/panel-styles.service';
import {MaterialService} from '../material/material.service';
import html2canvas from 'html2canvas';
import {TitleCasePipe} from '@angular/common';
import {Height} from '../height/height';
import {PanelStyles} from '../panel-styles/panel-styles';
import {Material} from '../material/material';
import {WorksurfaceService} from '../worksurface/worksurface.service';
import {Worksurface} from '../worksurface/worksurface';
import {Door} from '../door/door';
import {DoorService} from '../door/door.service';


@Component({
  selector: 'app-selections-accordion',
  imports: [TitleCasePipe, Height, PanelStyles, Material, Worksurface, Door],
  templateUrl: './selections-accordion.html',
  styleUrl: './selections-accordion.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Injectable({
  providedIn: 'root'
})
export class SelectionsAccordion {
  private http = inject(HttpClient);

  private heightService = inject(HeightService);
  private panelStylesService = inject(PanelStylesService);
  protected materialService = inject(MaterialService);
  protected worksurfaceService = inject(WorksurfaceService);
  protected doorService = inject(DoorService);

  protected selectedHeight = computed(() => this.heightService.selectedHeight());
  protected selectedPanelStyle = computed(() => this.panelStylesService.selectedStyle());
  protected selectedWorksurface = computed(() => this.worksurfaceService.selectedWorksurface());
  protected selectedDoor = computed(() => this.doorService.selectedDoor());

  //protected zones = ['T4', 'T3', 'T2', 'T1', 'T0'];

  readonly zones = computed(() => {
    const height = this.heightService.selectedHeight();
    const style = this.panelStylesService.selectedStyle();

    let result = ['T4', 'T3', 'T2', 'T1', 'T0'];

    if (height == 84) {
      result = result.filter(tab => tab !== 'T4');

      if(style?.endsWith('A')){
      } else if(style?.endsWith('B')){
        result = result.filter(tab => tab !== 'T3');
      } else if(style?.endsWith('C')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('D')) {
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('E')) {
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('F')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('G')) {
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      }
    } else if(height === 95 || height === 108) {
      if (style?.endsWith('A')){
      } else if(style?.endsWith('B')){
        result = result.filter(tab => tab !== 'T4');
      } else if(style?.endsWith('C')){
        result = result.filter(tab => tab !== 'T3');
      } else if(style?.endsWith('D')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T4');
      } else if(style?.endsWith('E')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('F')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('G')) {
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('H')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T2');
      } else if(style?.endsWith('I')) {
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('J')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('K')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('L')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('M')) {
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('N')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('O')) {
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      } else if(style?.endsWith('P')) {
        result = result.filter(tab => tab !== 'T4');
        result = result.filter(tab => tab !== 'T3');
        result = result.filter(tab => tab !== 'T2');
        result = result.filter(tab => tab !== 'T1');
      }
    }

    return result;
  });


  protected selections = computed(() =>
    this.zones().map(zone => ({
      zone,
      ...this.materialService.getSelection(zone)()
    }))
  );

  protected getColorLabel = this.materialService.getColorLabel.bind(this.materialService);

  toggleAccordion(index: number): void {
    (window as any).toggleAccordion(index);
  }

  downloadPanel() {
    const panel = document.getElementById('panel_image');
    if (!panel) return;

    html2canvas(panel, {backgroundColor: '#ffffff'}).then(canvas => {
      const link = document.createElement('a');
      link.download = 'panel_screenshot.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    })
  }

  hideSuccess() {
    document.getElementById('email_good')?.classList.add('hidden');
  }

  emailSelection() {
    console.log("Email Button Clicked!");
    (document.getElementById('send_email') as HTMLButtonElement).disabled = true;
    (document.getElementById('send_email') as HTMLButtonElement).textContent = 'Sending...';
    const domain = window.location.hostname;
    const first_name = (document.getElementById('first-name') as HTMLInputElement).value;
    const last_name = (document.getElementById('last-name') as HTMLInputElement).value;
    const email = (document.getElementById('email') as HTMLInputElement).value;
    const door_type = (document.getElementById('door_type') as HTMLInputElement).value;
    const door_color = (document.getElementById('door_color') as HTMLInputElement).value;
    const height = (document.getElementById('height') as HTMLInputElement).value;
    const style = (document.getElementById('style') as HTMLInputElement).value;
    const worksurface = (document.getElementById('worksurface') as HTMLInputElement).value;

    let t4 = ""
    if(document.getElementById('T4')){
      t4 = (document.getElementById('T4') as HTMLInputElement).value;
    } else {
      t4 = "NA";
    }
    let t3 = "";
    if(document.getElementById('T3')){
      t3 = (document.getElementById('T3') as HTMLInputElement).value;
    } else {
      t3 = "NA";
    }
    let t2 = "";
    if(document.getElementById('T2')){
      t2 = (document.getElementById('T2') as HTMLInputElement).value;
    } else {
      t2 = "NA";
    }
    let t1 = "";
    if(document.getElementById('T1')){
      t1 = (document.getElementById('T1') as HTMLInputElement).value;
    } else {
      t1 = "NA";
    }
    let t0 = "";
    if(document.getElementById('T0')){
      t0 = (document.getElementById('T0') as HTMLInputElement).value;
    } else {
      t0 = "NA";
    }
    console.log(first_name, last_name, email);
    console.log(t4);
    console.log(t3);
    console.log(t2);
    console.log(t1);
    console.log(t0);

    const data = {
      domain: domain,
      first_name: first_name,
      last_name: last_name,
      email: email,
      door_type: door_type,
      door_color: door_color,
      worksurface: worksurface,
      height: height,
      style: style,
      t4: t4,
      t3: t3,
      t2: t2,
      t1: t1,
      t0: t0,
    };

    this.http.post('https://95sapphirecustomizer.skutchi.com/send_email.php', data)
      .subscribe(res => {
        console.log(res);
        document.getElementById('email_good')?.classList.remove('hidden');
        (document.getElementById('send_email') as HTMLButtonElement).disabled = false;
        (document.getElementById('send_email') as HTMLButtonElement).textContent = 'Send';
      });
  }
}
